// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#Dashboard_root__XpyZB {
  min-height: 100%;
  background-color: #ecf0f1;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Dashboard_dashboard__1OjgL {
  display: flex;
  min-height: 100vh;
  background-color: #ecf0f1;
  font-family: Arial, sans-serif;
}

.Dashboard_sidebar__7SHQJ {
  width: 250px;
  background-color: #2c3e50;
  color: #ecf0f1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}

.Dashboard_userInfo__GF33u {
  margin-bottom: 20px;
}

.Dashboard_deviceList__vVc2B {
  margin-bottom: 20px;
}

.Dashboard_deviceList__vVc2B ul {
  list-style: none;
  padding: 0;
}

.Dashboard_deviceList__vVc2B li {
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.Dashboard_deviceList__vVc2B li:hover {
  background-color: #34495e;
}

.Dashboard_activeDevice__EfbtB {
  background-color: #1abc9c;
}

.Dashboard_languageSelector__XD4DG {
  margin-bottom: 20px;
}

.Dashboard_languageFlags__yj4LH {
  display: flex;
  gap: 10px;
}

.Dashboard_languageFlags__yj4LH .Dashboard_fi__DmNJs {
  font-size: 24px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.Dashboard_languageFlags__yj4LH .Dashboard_fi__DmNJs:hover {
  opacity: 1;
  transform: scale(1.1);
}

.Dashboard_activeFlag__mMhta {
  opacity: 1;
  border: 2px solid #ffffff;
}

.Dashboard_logoutButton__fGG8R {
  background-color: #e74c3c;
  color: #ffffff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Dashboard_logoutButton__fGG8R:hover {
  background-color: #c0392b;
}

.Dashboard_secondaryActionButton__xlem0 {
  background-color: #1abc9c;
  color: #ffffff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Dashboard_secondaryActionButton__xlem0:hover {
  background-color: #16a085;
}

.Dashboard_kioskLeafletButton__NsfOv {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 12px;
  text-decoration: none;
  color: #ecf0f1;
  background: linear-gradient(135deg, rgba(26, 188, 156, 0.24) 0%, rgba(52, 152, 219, 0.2) 100%);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.16);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.Dashboard_kioskLeafletButton__NsfOv:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.22);
  background: linear-gradient(135deg, rgba(26, 188, 156, 0.34) 0%, rgba(52, 152, 219, 0.28) 100%);
}

.Dashboard_kioskLeafletEyebrow__Zf1if {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.8;
}

.Dashboard_kioskLeafletLabel__bvplK {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
}

.Dashboard_kioskLeafletHint__2Ify3 {
  font-size: 0.82rem;
  opacity: 0.82;
}

.Dashboard_mainContent__C\\+DoX {
  flex: 1 1;
  padding: 20px;
  background-color: #ecf0f1;
  box-sizing: border-box;
}

.Dashboard_charts__L2b3H {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.Dashboard_tiles__\\+eN4y {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 20px;
}

.Dashboard_tile__TBbtC {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  text-align: center;
}

.Dashboard_modalForm__K3a-b {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.Dashboard_modalField__nmn4l {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.Dashboard_modalField__nmn4l label {
  color: #355061;
  font-size: 0.86rem;
  font-weight: 600;
  text-align: left;
}

.Dashboard_modalError__dwOWc {
  margin: 0;
  color: #c0392b;
  font-size: 0.9rem;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.module.css"],"names":[],"mappings":"AAAA;;;EAGE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,8FAA8F;EAC9F,2CAA2C;EAC3C,2CAA2C;EAC3C,oFAAoF;AACtF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,+FAA+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["html,\nbody,\n#root {\n  min-height: 100%;\n  background-color: #ecf0f1;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.dashboard {\n  display: flex;\n  min-height: 100vh;\n  background-color: #ecf0f1;\n  font-family: Arial, sans-serif;\n}\n\r\n.sidebar {\r\n  width: 250px;\r\n  background-color: #2c3e50;\r\n  color: #ecf0f1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.userInfo {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.deviceList {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.deviceList ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.deviceList li {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.deviceList li:hover {\r\n  background-color: #34495e;\r\n}\r\n\r\n.activeDevice {\r\n  background-color: #1abc9c;\r\n}\r\n\r\n.languageSelector {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.languageFlags {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.languageFlags .fi {\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  opacity: 0.7;\r\n  transition: opacity 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.languageFlags .fi:hover {\r\n  opacity: 1;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.activeFlag {\r\n  opacity: 1;\r\n  border: 2px solid #ffffff;\r\n}\r\n\r\n.logoutButton {\n  background-color: #e74c3c;\n  color: #ffffff;\n  padding: 10px;\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.logoutButton:hover {\n  background-color: #c0392b;\n}\n\n.secondaryActionButton {\n  background-color: #1abc9c;\n  color: #ffffff;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.secondaryActionButton:hover {\n  background-color: #16a085;\n}\n\n.kioskLeafletButton {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  text-decoration: none;\n  color: #ecf0f1;\n  background: linear-gradient(135deg, rgba(26, 188, 156, 0.24) 0%, rgba(52, 152, 219, 0.2) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.16);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;\n}\n\n.kioskLeafletButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.22);\n  background: linear-gradient(135deg, rgba(26, 188, 156, 0.34) 0%, rgba(52, 152, 219, 0.28) 100%);\n}\n\n.kioskLeafletEyebrow {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n\n.kioskLeafletLabel {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.kioskLeafletHint {\n  font-size: 0.82rem;\n  opacity: 0.82;\n}\n\r\n.mainContent {\r\n  flex: 1;\r\n  padding: 20px;\r\n  background-color: #ecf0f1;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.charts {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tiles {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.tile {\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n  text-align: center;\n}\n\n.modalForm {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.modalField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.modalField label {\n  color: #355061;\n  font-size: 0.86rem;\n  font-weight: 600;\n  text-align: left;\n}\n\n.modalError {\n  margin: 0;\n  color: #c0392b;\n  font-size: 0.9rem;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Dashboard_root__XpyZB`,
	"dashboard": `Dashboard_dashboard__1OjgL`,
	"sidebar": `Dashboard_sidebar__7SHQJ`,
	"userInfo": `Dashboard_userInfo__GF33u`,
	"deviceList": `Dashboard_deviceList__vVc2B`,
	"activeDevice": `Dashboard_activeDevice__EfbtB`,
	"languageSelector": `Dashboard_languageSelector__XD4DG`,
	"languageFlags": `Dashboard_languageFlags__yj4LH`,
	"fi": `Dashboard_fi__DmNJs`,
	"activeFlag": `Dashboard_activeFlag__mMhta`,
	"logoutButton": `Dashboard_logoutButton__fGG8R`,
	"secondaryActionButton": `Dashboard_secondaryActionButton__xlem0`,
	"kioskLeafletButton": `Dashboard_kioskLeafletButton__NsfOv`,
	"kioskLeafletEyebrow": `Dashboard_kioskLeafletEyebrow__Zf1if`,
	"kioskLeafletLabel": `Dashboard_kioskLeafletLabel__bvplK`,
	"kioskLeafletHint": `Dashboard_kioskLeafletHint__2Ify3`,
	"mainContent": `Dashboard_mainContent__C+DoX`,
	"charts": `Dashboard_charts__L2b3H`,
	"tiles": `Dashboard_tiles__+eN4y`,
	"tile": `Dashboard_tile__TBbtC`,
	"modalForm": `Dashboard_modalForm__K3a-b`,
	"modalField": `Dashboard_modalField__nmn4l`,
	"modalError": `Dashboard_modalError__dwOWc`
};
export default ___CSS_LOADER_EXPORT___;
